import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import { startAlerta } from "../ui/alertas";

export const fetchMateriales =
  (textoBuscado = "", materialesInactivos) =>
  async (dispatch) => {
    dispatch({ type: types.abmMaterialesTraerStart });

    try {
      const response = await fetchConToken(`NomencladorProtesis/obtenerMateriales/${textoBuscado}/${materialesInactivos}`);
      let body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.abmMaterialesTraerSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cargar los materiales.",
        "Ha ocurrido un error. Intente nuevamente"
      );
      dispatch({ type: types.abmMaterialesTraerError });
    }
  };

  export const guardarMaterial = (codigoNum, datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      
      let response;
      if (codigoNum > 0) {
        response = await fetchConToken(`NomencladorProtesis/${codigoNum}`, datos, "PUT");
      } else {
        response = await fetchConToken(`NomencladorProtesis`, datos, "POST");
      }
  
      const body = await response.json();
  
      if (response.ok) {
        dispatch(
          startAlerta(
            "Material guardado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(finishSpinner());
        dispatch(fetchMateriales(null));
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar un nuevo material.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  export const eliminarMaterial = (codigoNum) => async (dispatch)=>{
    try{
      const response = await fetchConToken(`NomencladorProtesis/${codigoNum}`,'','DELETE');
      const body = await response.json();
      if(response.ok){
        dispatch(startAlerta("Material eliminado correctamente", 'success', 'Comando Exitoso'));
        dispatch(finishSpinner());
      }else{
        throw body;
      }
    }catch(error){
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al eliminar el material.", "Ha ocurrido un error. Intente nuevamente")
    }
  }

  